import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { get } from 'lodash'

import { Input } from 'components/input/Input'
import { Text } from 'components/text/Text'

import styles from './RadioButton.module.scss'

export const RadioButton = ({ index, name, className, onChange, value, option, isDisabled, listType }) => {
  const optionId = get(option, 'id')
  const isChecked = optionId === value

  return (
    <div
      data-key-id={`radio-button-${index}`}
      className={classNames(styles.label, className, {
        [styles.active]: isChecked,
        [styles.blockItem]: listType === 'block',
        [styles.columnsItem]: listType === 'columns',
      })}
      onClick={event => {
        event.preventDefault()
        event.nativeEvent.stopImmediatePropagation()

        if (value !== optionId && !isDisabled) {
          onChange(optionId)
        }
      }}>
      <div className={styles.container} data-key-id={isChecked ? `radio-button-${index}-checked` : null}>
        <Input
          className={styles.input}
          type="radio"
          name={name}
          value={optionId}
          onChange={onChange}
          checked={isChecked}
          disabled={isDisabled}
        />
      </div>

      <Text>{get(option, 'title')}</Text>
    </div>
  )
}

RadioButton.propTypes = {
  index: PropTypes.number.isRequired,
  name: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  option: PropTypes.object.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  isDisabled: PropTypes.bool,
  listType: PropTypes.oneOf(['block', 'inline', 'columns']),
}
